<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- Config Section -->
    <div class="card-field-container">
      <div class="label-oos mb-4">Config</div>
      <j-form-page
        v-if="showPageForm"
        ref="formEditPage"
        :mode="'edit'"
        :is-popover="false"
        :data-page="data_general"
        :icon-options="icon_options"
      />
      <div
        v-if="showPageForm"
        class="d-flex mt-3"
      >
        <button
          class="btn-blue"
          @click="updateGeneral"
        >
          Update
        </button>
        <div
          class="cursor-pointer mt-2 ml-3"
          @click="deleteThisPage"
        >
          <i class="fa fa-trash"/> Delete this page
        </div>
      </div>
    </div>

    <!-- Component Section -->
    <div
      v-if="dataPage.type === 'visible' || dataPage.type === 'invisible'"
      class="pb-3"
      style="max-height: calc(100vh - 474px); overflow-x: auto;"
    >
      <!-- Loading -->
      <div
        v-if="isLoading"
        id="component-list"
      >
        <j-skeleton-component />
      </div>

      <!-- Main loop -->
      <div
        v-else
        id="component-list"
      >
        <!-- If not have component -->
        <h5 v-if="listComponent.length === 0">No component on this page</h5>

        <div
          v-for="(component, index) in listComponent"
          :key="component.id"
          :class="{
            'selected': dataEdit && dataEdit.id === component.id,
            'canvas': component.type === 'canvas'
          }"
          class="component-list"
        >
          <!-- Dummy Experience Manager -->
          <template v-if="component.type === 'form_ui' || component.type === 'multiple_form_ui'">
            <!-- Dummy Table View -->
            <dummy-table-view
              v-if="component.info && JSON.parse(component.info).default_view === 'table_view'"
              :data-component="component"
            />

            <!-- Dummy Table Requestor View -->
            <dummy-table-view
              v-else-if="component.info && JSON.parse(component.info).default_view === 'table_requester_view'"
              :data-component="component"
              :type="'requestor'"
            />

            <!-- Dummy Table Approver View -->
            <dummy-table-view
              v-else-if="component.info && JSON.parse(component.info).default_view === 'table_approver_view'"
              :data-component="component"
              :type="'approver'"
            />

            <!-- Dummy Create View -->
            <dummy-create-detail-view
              v-else-if="component.info && JSON.parse(component.info).default_view === 'create_view'"
              :data-component="component"
              :type="'create'"
            />

            <!-- Dummy Detail View -->
            <dummy-create-detail-view
              v-else-if="component.info && JSON.parse(component.info).default_view === 'detail_view'"
              :data-component="component"
              :type="'detail'"
            />

            <!-- Dummy Calendar View -->
            <dummy-calendar-view
              v-else-if="component.info && JSON.parse(component.info).default_view === 'calendar_view'"
              :data-component="component"
            />

            <!-- Dummy Export View -->
            <dummy-export-view
              v-else-if="component.info && JSON.parse(component.info).default_view === 'export_view'"
              :data-component="component"
            />
          </template>

          <!-- Dummy HTML -->
          <dummy-html
            v-else-if="component.type === 'html'"
            :data-component="component"
          />

          <!-- Dummy Canvas -->
          <dummy-canvas
            v-else-if="component.type === 'canvas'"
            :data-component="component"
          />

          <!-- Dummy Attendance -->
          <dummy-attendance-my-log
            v-else-if="component.type === 'attendance_my_log'"
            :data-component="component"
          />
          <dummy-attendance-monitor
            v-else-if="component.type === 'attendance_monitor'"
            :data-component="component"
          />
          <dummy-attendance-report
            v-else-if="component.type === 'attendance_report'"
            :data-component="component"
          />
          <dummy-attendance-config
            v-else-if="component.type === 'attendance_config'"
            :data-component="component"
          />
          <dummy-co-attendance
            v-else-if="
              component.type === 'co_attendance_requestor' ||
                component.type === 'co_attendance_approver'
            "
            :data-component="component"
            :type="component.type === 'co_attendance_requestor' ? 'requestor' : 'approver'"
          />

          <!-- Dummy Leave -->
          <dummy-leave
            v-else-if="
              component.type === 'leave_requestor' ||
                component.type === 'leave_approver' ||
                component.type === 'leave_monitor'
            "
            :data-component="component"
            :type="component.type.split('_')[1]"
          />
          <dummy-leave-config
            v-else-if="component.type === 'leave_config'"
            :data-component="component"
          />
          <dummy-leave-report
            v-else-if="component.type === 'leave_report'"
            :data-component="component"
          />

          <!-- Dummy Overtime -->
          <dummy-overtime-config
            v-else-if="component.type === 'overtime_config'"
            :data-component="component"
          />
          <dummy-overtime
            v-else-if="
              component.type === 'overtime_requestor' ||
                component.type === 'overtime_approver' ||
                component.type === 'overtime_monitor'
            "
            :data-component="component"
            :type="component.type.split('_')[1]"
          />
          <dummy-overtime-report
            v-else-if="component.type === 'overtime_report'"
            :data-component="component"
          />

          <!-- Dummy Timesheet -->
          <dummy-timesheet-config
            v-else-if="component.type === 'timesheet_config'"
            :data-component="component"
          />
          <dummy-timesheet-report
            v-else-if="component.type === 'timesheet_report'"
            :data-component="component"
          />
          <dummy-timesheet-approval
            v-else-if="component.type === 'timesheet_approval'"
            :data-component="component"
          />

          <!-- Dummy Employee Setup -->
          <dummy-employee-setup
            v-else-if="component.type === 'employee_setup'"
            :data-component="component"
          />

          <!-- Dummy User Setup -->
          <dummy-user-setup
            v-else-if="component.type === 'user_setup'"
            :data-component="component"
          />

          <!-- Dummy Access Management -->
          <dummy-access-management
            v-else-if="component.type === 'access_management'"
            :data-component="component"
          />

          <!-- Dummy Embed URL -->
          <dummy-embed-url
            v-else-if="component.type === 'embed_url'"
            :data-component="component"
          />

          <!-- Dummy Hierarchy &  Custom Hierarchy -->
          <dummy-hierarchy
            v-else-if="
              component.type === 'hierarchy' ||
                component.type === 'custom_hierarchy'
            "
            :data-component="component"
            :is-custom="component.type === 'custom_hierarchy'"
          />

          <!-- Default Component -->
          <div
            v-else
            class="pt-4"
          >
            <j-skeleton-component :length="1" />
          </div>

          <!-- Open Tab, Edit or Delete -->
          <div class="opentab-or-config">
            <div class="button">
              <!-- Open Tab -->
              <div
                v-if="
                  component.type === 'form_ui' ||
                    component.type === 'multiple_form_ui' ||
                    component.type === 'canvas'
                "
                class="open-tab"
                @click="onOpenNewtab(component)"
              >
                <i class="fa fa-external-link" />

                <!-- Tooltip -->
                <div class="tooltip-component">Open new tab</div>
              </div>

              <!-- Edit -->
              <div
                class="edit"
                @click="onClickEdit(index)"
              >
                <i class="fa fa-edit" />

                <!-- Tooltip -->
                <div class="tooltip-component">Edit component</div>
              </div>

              <!-- Delete -->
              <div
                class="delete"
                @click="onClickDelete(index)"
              >
                <i class="fa fa-trash" />

                <!-- Tooltip -->
                <div class="tooltip-component">Delete component</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Add component button -->
      <div
        v-if="!modeCreate"
        id="popover-button-event"
        class="add-component-app"
        @click="toogle"
      >
        + Add Component
      </div>

      <!-- Drowdown choosing component -->
      <div
        v-show="opened"
        class="card-master-container">
        <j-input
          v-model="filter_data"
          :error-required="false"
          placeholder="Search"
          class="p--10"/>
        <div
          v-for="(val, index) in data_component"
          :key="index">
          <div
            class="cursor-dropdown"
            @click="chooseMaster(val)">
            {{ val.name_master.toUpperCase() }}
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Form -->
    <b-modal
      ref="modalForm"
      class="mod-form modal-pages-component"
      centered
      no-close-on-backdrop
      no-close-on-esc
      no-stacking>
      <j-pages-form-setup
        v-if="showModalForm"
        :data-master="dataMaster"
        :data-edit="dataEdit"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        @close-modal="closeModalForm"
      />
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapState, mapActions } from 'vuex';
import ClickOutside from 'vue-click-outside';
import jPagesFormSetup from '@/views/pages/jPagesFormSetup';
import jFormPage from '@/views/setting/jFormPage';
// Dummy Component
import DummyTableView from '@/components/dummy/DummyTableView';
import DummyCreateDetailView from '@/components/dummy/DummyCreateDetailView';
import DummyCalendarView from '@/components/dummy/DummyCalendarView';
import DummyExportView from '@/components/dummy/DummyExportView';
import DummyHtml from '@/components/dummy/DummyHtml';
import DummyCanvas from '@/components/dummy/DummyCanvas';
import DummyAttendanceMyLog from '@/components/dummy/DummyAttendanceMyLog';
import DummyAttendanceMonitor from '@/components/dummy/DummyAttendanceMonitor';
import DummyAttendanceReport from '@/components/dummy/DummyAttendanceReport';
import DummyAttendanceConfig from '@/components/dummy/DummyAttendanceConfig';
import DummyCoAttendance from '@/components/dummy/DummyCoAttendance';
import DummyLeave from '@/components/dummy/DummyLeave';
import DummyLeaveConfig from '@/components/dummy/DummyLeaveConfig';
import DummyLeaveReport from '@/components/dummy/DummyLeaveReport';
import DummyOvertimeConfig from '@/components/dummy/DummyOvertimeConfig';
import DummyOvertime from '@/components/dummy/DummyOvertime';
import DummyOvertimeReport from '@/components/dummy/DummyOvertimeReport';
import DummyTimesheetConfig from '@/components/dummy/DummyTimesheetConfig';
import DummyTimesheetReport from '@/components/dummy/DummyTimesheetReport';
import DummyTimesheetApproval from '@/components/dummy/DummyTimesheetApproval';
import DummyEmployeeSetup from '@/components/dummy/DummyEmployeeSetup';
import DummyUserSetup from '@/components/dummy/DummyUserSetup';
import DummyAccessManagement from '@/components/dummy/DummyAccessManagement';
import DummyEmbedUrl from '@/components/dummy/DummyEmbedUrl';
import DummyHierarchy from '@/components/dummy/DummyHierarchy';
// Skeleton
import jSkeletonComponent from '@/views/experience-manager-v2/loading/jSkeletonComponent';

export default {
  components: {
    jPagesFormSetup,
    jFormPage,
    DummyTableView,
    DummyCreateDetailView,
    DummyCalendarView,
    DummyExportView,
    DummyHtml,
    DummyCanvas,
    DummyAttendanceMyLog,
    DummyAttendanceMonitor,
    DummyAttendanceReport,
    DummyAttendanceConfig,
    DummyCoAttendance,
    DummyLeave,
    DummyLeaveConfig,
    DummyLeaveReport,
    DummyOvertimeConfig,
    DummyOvertime,
    DummyOvertimeReport,
    DummyTimesheetConfig,
    DummyTimesheetReport,
    DummyTimesheetApproval,
    DummyEmployeeSetup,
    DummyUserSetup,
    DummyAccessManagement,
    DummyEmbedUrl,
    DummyHierarchy,
    jSkeletonComponent,
  },
  directives: {
    ClickOutside,
  },
  props: {
    dataPage: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: true,
      showModalForm: false,
      dataComponent: [],
      data_component: [],
      modeCreate: false,
      dataMaster: null,
      dataEdit: null,
      modeEdit: false,
      opened: false,
      filter_data: '',

      // data general
      data_general: {
        icon: null,
        type: '',
        title: '',
        show_option: null,
      },
      showPageForm: false,
      icon_options: [],
      applicationId: 0,
      order: 0,

      itemsBreadcrumb: [{ text: 'APPLICATION', to: '/setting/application' }],
      listComponent: [],
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_component_master', 'list_component', 'component_created', 'side_menu']),
  },
  watch: {
    list_component_master(data) {
      // eslint-disable-next-line
      const dataMaster = Array.from(Object.create(data)).sort((a, b) => ((a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)));
      // eslint-disable-next-line
      this.dataComponent = dataMaster.map((v) => {
        const x = v;
        x.name_master = this.componentType(v.name);
        return x;
      });
      // eslint-disable-next-line
      this.data_component = dataMaster.map((v) => {
        const x = v;
        x.name_master = this.componentType(v.name);
        return x;
      });
    },

    component_created() {
      this.getListComponentByPage();
    },

    filter_data(val) {
      // eslint-disable-next-line
      this.data_component = this.dataComponent.filter(app => app.name_master.toUpperCase().includes(val.toUpperCase()));
    },
  },
  async created() {
    // const applicationId = this.$route.params.applicationId;
    // const param = {
    //   params: {
    //     page: 1,
    //     limit: 0,
    //     column: 'id',
    //     sort: 'asc',
    //     query: '',
    //     query_type: '',
    //   },
    // };
    // await this.actionGetSideMenuList({ applicationId, param });

    setTimeout(() => {
      // const pagesId = this.$route.params.pageId;
      // const dataGeneral = this.side_menu.find(e => e.id === Number(pagesId));
      const dataGeneral = this.dataPage;
      this.data_general.title = dataGeneral.name;
      this.data_general.type = dataGeneral.type;
      this.data_general.show_option = dataGeneral.show_option;
      // this.data_general.icon = { id: dataGeneral.icon_id };

      this.applicationId = dataGeneral.application_id;
      this.order = dataGeneral.order;

      // const appIdHash = this.$route.params.applicationId;
      // this.itemsBreadcrumb.push({ text: this.$route.params.applicationName.toUpperCase(), to: `/setting/application/${appIdHash}` });
      // this.itemsBreadcrumb.push({ text: dataGeneral.name.toUpperCase(), active: true });

      this.getListComponentByPage();
      this.getListIcon();
    }, 500);
  },
  methods: {
    ...mapActions('jStoreApplication', ['listComponentMaster', 'getListComponent', 'deleteComponent', 'actionGetListIcons', 'actionGetSideMenuList']),
    ...mapActions('jStoreSetting', ['actionDeletePage', 'actionUpdatePage']),

    openModalForm() {
      this.$refs.modalForm.show();
      this.showModalForm = true;
    },

    closeModalForm() {
      this.$refs.modalForm.hide();
      this.showModalForm = false;
      this.modeCreate = false;
      this.modeEdit = false;
      this.dataMaster = null;
      this.dataEdit = null;
    },

    deleteThisPage() {
      this.$swal({
        title: 'Delete Page',
        html: `Are you sure to delete page "<span style="font-family: Poppins-Medium; font-size: 18px;">${this.dataPage.name}</span>"?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.value) {
          const res = await this.actionDeletePage(this.dataPage.id);
          if (!res.error) {
            this.$emit('reload', true);
          }
        }
      });
    },

    async getListIcon() {
      const params = {
        page: 1,
        limit: 100,
        column: 'id',
        sort: 'desc',
        query: '',
        query_type: '',
      };
      const res = await this.actionGetListIcons(params);
      if (!res.error) {
        this.icon_options = res.data.map(val => ({
          name: val.name,
          label: val.name,
          id: val.id,
          icon_grey: val.icon_active,
          is_delete: false,
        }));
        const dataIcon = this.icon_options.find(f => f.id === this.dataPage.icon_id);
        this.data_general.icon = dataIcon || null;
        this.showPageForm = true;
      }
    },

    async updateGeneral() {
      this.$refs.formEditPage.getData().then(async (data) => {
        const pagesId = this.dataPage.id;
        const parameter = {
          page_id: Number(pagesId),
          application_id: Number(this.applicationId),
          name: data.titlePage,
          type: this.dataPage.type,
          icon_id: data.selectedIcon.id,
          show_option: data.displayMode,
          order: this.order,
          parent_id: this.dataPage.parent_id,
        };
        const res = await this.actionUpdatePage({ parameter, useLoading: true });
        if (!res.error) {
          this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Update Success');
          setTimeout(() => {
            // this.$router.go();
            this.$emit('reload', false);
          }, 500);
        }
      });
    },

    // GLOBAL METHOD FOR LISTING COMPONENT MASTER
    getListComponentByPage() {
      this.listComponent = [];
      const parameters = {
        limit: 10,
        page: 1,
        column: 'id',
        sort: 'asc',
      };
      const pagesId = this.dataPage.id;
      this.getListComponent({ params: parameters, pages_id: pagesId }).then((res) => {
        this.listComponent = res.data;
        this.isLoading = false;
      });
    },

    getListComponentMaster() {
      const parameter = {
        limit: 0,
        page: 1,
        column: 'id',
        sort: 'asc',
        query: '',
        query_type: '',
      };
      this.listComponentMaster({ params: parameter });
    },

    toogle() {
      this.opened = !this.opened;
      this.getListComponentMaster();
    },

    hide() {
      this.opened = false;
    },

    chooseMaster(data) {
      const val = data;
      val.pages_id = this.dataPage.id;
      this.opened = false;
      const listComponentMaster = [
        'advanced_form_table',
        'analytic',
        'analytic_v2',
        'attendance_config',
        'attendance_monitor',
        'attendance_my_log',
        'attendance_report',
        'basic_payroll_config',
        'board',
        'channel',
        'co_attendance_approver',
        'co_attendance_monitor',
        'co_attendance_requestor',
        'company_payroll_config',
        'component_payroll_config',
        'cost_center',
        'custom_hierarchy',
        'digital_document',
        'digital_signature',
        'digital_signature_workflow_requester',
        'digital_signature_workflow_approver',
        'discussion',
        'dynamic_workflow',
        'dynamic_workflow_approver',
        'employee_grade_setup',
        'employee_payslip',
        'employee_setup',
        'flow_setup',
        'form',
        'form_ui',
        'multiple_form_ui',
        'canvas',
        'formula',
        'hierarchy',
        'html',
        'leave_approver',
        'leave_config',
        'leave_monitor',
        'leave_requestor',
        'leave_report',
        'location_setup',
        'personal_payslip',
        'position_setup',
        'orgunit_setup',
        'payroll_area',
        'run_payroll',
        'tax_location',
        'timesheet',
        'timesheet_approval',
        'timesheet_config',
        'timesheet_report',
        'widget',
        'workflow',
        'workflow_approver',
      ];

      const times = [
        'attendance_config',
        'attendance_monitor',
        'attendance_my_log',
        'attendance_report',
        'co_attendance_approver',
        'co_attendance_monitor',
        'co_attendance_requestor',
        'leave_approver',
        'leave_config',
        'leave_monitor',
        'leave_requestor',
        'leave_report',
        'timesheet',
        'timesheet_approval',
        'timesheet_config',
        'timesheet_report',
      ];

      if (listComponentMaster.includes(val.name.toLowerCase())) {
        if (times.includes(val.name) &&
            this.list_component.some(list => listComponentMaster.includes(list.type))) {
          this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Not allowed to create more than one Times Component on the same page');
        } else {
          this.modeCreate = true;
          this.dataMaster = val;
          this.dataComponent = [];
          this.data_component = [];
          this.openModalForm();
        }
      } else {
        this.modeCreate = true;
        this.dataMaster = val;
        this.dataComponent = [];
        this.data_component = [];
        this.openModalForm();
      }
    },

    // GLOBAL METHOD FOR EDIT AND DELETE
    onClickEdit(index) {
      this.dataEdit = this.list_component[index];
      this.modeEdit = true;
      this.dataMaster = {
        id: Number(this.dataEdit.component_master_id),
        name: this.dataEdit.type,
      };
      this.modeCreate = true;
      this.openModalForm();
    },

    onClickDelete(index) {
      this.$swal({
        title: 'Delete Component',
        html: `Are you sure to delete component "<span style="font-family: Poppins-Medium; font-size: 18px;">${this.list_component[index].name}</span>"?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const dataParam = {
            id: this.list_component[index].component_master_id,
            component_id: this.list_component[index].id,
          };
          this.deleteComponent(dataParam);
        }
      });
    },

    onOpenNewtab(component) {
      const componentInfo = JSON.parse(component.info);
      let url = '';
      if (component.type === 'form_ui') {
        url = `${window.location.origin}/#/experience-manager/update/${componentInfo.form_ui_id}`;
      }
      if (component.type === 'multiple_form_ui') {
        url = `${window.location.origin}/#/multiple-experience-manager/update/${componentInfo.form_ui_id}`;
      }
      window.open(url, '_blank');
    },

    componentType(type) {
      if (type === 'form_ui') {
        return 'single_experience_manager';
      } else if (type === 'multiple_form_ui') {
        return 'multiple_experience_manager';
      }
      return type;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap-btn-config {
  position: relative;

  .tooltip-component {
    position: absolute;
    top: 25px;
    right: 0;
    display: none;
    background-color: white;
    padding: 6px;
    border-radius: 10px;
    box-shadow: 0px 1px 12px rgba(114, 109, 109, 0.25);
    font-family: 'Poppins-Medium';
    font-size: 12px;
    color: #606060;
    white-space: nowrap;
    transition: display ease 0.4s;
    z-index: 1;
  }
  &:hover {
    .tooltip-component {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/jPagesSetting.vue